import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { Observable, of } from 'rxjs';
import { AuthHttpService } from '../auth-data/auth-http.service';
import { IResponseInfo } from '../http/http.data';
import { Notification, NotificationStateEnum } from './notification.model';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class NotificationDataService {
  private _notificationsUrl: string = '/notifications';

  constructor(private _authHttpService: AuthHttpService) {}

  // TODO: handle pagination correctly
  getNotifications(page?: number): Observable<List<Notification>> {
    const url = this._notificationsUrl;

    return this._authHttpService
      .get(url)
      .pipe(
        map(({ body, ..._ }: IResponseInfo) =>
          Notification.fromJsonList(body['notifications'])
        )
      );
  }

  setState(
    notificationId: string,
    state: NotificationStateEnum
  ): Observable<Notification> {
    const url = `${this._notificationsUrl}/${notificationId}/state`;
    const body = {
      state: state,
    };

    return this._authHttpService
      .put(url, body, {}, false)
      .pipe(
        map(
          ({ body, ..._ }: IResponseInfo) =>
            new Notification(body['updated_notification'])
        )
      );
  }

  batchSeen(notificationIds: List<string>): Observable<List<string>> {
    const url = `${this._notificationsUrl}/seen`;

    return this._authHttpService.post(url, notificationIds).pipe(
      map(({ body, ..._ }: IResponseInfo) => body['updated_notifications']),
      catchError((error) => {
        console.error(error); // TODO: handle errors properly

        return of(List<Notification>([]));
      })
    );
  }
}
